var map = {
	"./goldcoin/pop-up-gold-icon-0.png": 60289,
	"./memetown/pop-up-gold-icon-0.png": 21501,
	"./reflection/pop-up-gold-icon-0.png": 34004,
	"./tapcoin/pop-up-gold-icon-0.png": 9611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44075;